import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { PlatformHeader } from "@/components/abigail/PlatformHeader";
import welcomeBackground from "@/assets/abigail-background-bv.png";

export const Route = createFileRoute("/_authenticated/bem-vindo")({
  component: WelcomePage,
});

function WelcomePage() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-background">
        <img
          src={welcomeBackground}
          alt=""
          className="h-full w-full object-cover"
        />
      </div>
      <PlatformHeader />

      <main className="flex flex-1 items-end justify-center px-4 pt-10 pb-24 sm:pb-32">
        <section className="w-full max-w-sm">
          <Link
            to="/chat"
            className="bg-ember shadow-ember flex h-14 w-full items-center justify-center gap-3 rounded-xl text-sm font-semibold tracking-wide text-primary-foreground transition-opacity hover:opacity-90"
          >
            Iniciar sua Jornada
            <ArrowRight className="h-4 w-4" />
          </Link>
        </section>
      </main>
    </div>
  );
}
